/* generated by pull.js */
const manifest = {
  editorOnly: true,
  name: 'Save blocks as image',
  description: 'Right click the code area to export blocks as SVG/PNG images.',
  tags: [],
  credits: [
    {
      name: 'summerscar'
    }
  ],
  dynamicDisable: true,
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  enabledByDefault: true
};
export default manifest;
